import { TextField } from 'mui-rff';
import React from 'react';

import { MenuItem, Stack } from '@mui/material';
import { DEFAULT_FONT_FAMILIES } from '@wp-block-builder/inputs/base/FontFamilyInput';

import WpDocumentColorPickerInput from './WpDocumentColorPickerInput';

export default function BasicLayoutPropertiesInput() {
  return (
    <Stack spacing={4} mb={1}>
      <WpDocumentColorPickerInput
        label="Email backdrop"
        nameRoot="configuration.backdropStyle"
        name="backgroundColor"
        templateName="backgroundColorTemplate"
      />
      <WpDocumentColorPickerInput
        label="Canvas color"
        nameRoot="configuration.canvasStyle"
        name="backgroundColor"
        templateName="backgroundColorTemplate"
      />
      <TextField select variant="standard" label="Font stack" name="configuration.backdropStyle.fontFamily">
        {DEFAULT_FONT_FAMILIES.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ fontFamily: option.value }}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <WpDocumentColorPickerInput
        label="Text color"
        nameRoot="configuration.backdropStyle"
        name="color"
        templateName="colorTemplate"
      />
      <WpDocumentColorPickerInput
        label="Accent color (default for links, buttons, and avatars)"
        nameRoot="configuration.linkStyle"
        name="color"
        templateName="colorTemplate"
      />
    </Stack>
  );
}
